import { Directive, ElementRef, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CoreCOMService } from "../../services/com.service";
import * as _ from "lodash";

@Directive({
  selector: "a[href]"
})
/** Browser Direktive für <a href=""></a> **/
export class CoreBrowserDirective implements OnInit {

  ngOnInit(): void {

    const nativeElement = this._el.nativeElement;

    if (nativeElement.hasAttribute("href")) {
      let currentHref: string = nativeElement.getAttribute("href");
      currentHref = currentHref.trim();

      if (_.startsWith(currentHref.toLocaleLowerCase(), "http")) {
        nativeElement.setAttribute("href", "browser" + currentHref);
      }
    }
  }

  constructor(private _el: ElementRef, private _router: Router, private _coreCOMService: CoreCOMService) {
  }
}
